export default __webpack_public_path__ + "static/media/AmorinWiseBackground.0c84b505.jpg";